// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

interface SupportPortalUrlResult {
    supportPortalUrl: string
    supportPortalMessage: string
}

/**
 * Gets the support portal URL and associated message.
 * In the test environment, redirects to the live Connect Direct site.
 * Use this function in non-component contexts (e.g., constants files).
 *
 * @returns {SupportPortalUrlResult} - The support portal URL and message
 */
export const getSupportPortalUrl = (): SupportPortalUrlResult => {
    const isTestEnvironment = CONFIG.ENVIRONMENT === "tst"

    const supportPortalUrl = isTestEnvironment
        ? "https://connect-direct.energynetworks.org/"
        : CONFIG.SN_PORTAL_URL

    const supportPortalMessage = isTestEnvironment
        ? "This link will redirect you to the live Connect Direct site. Please log in and raise a support ticket from here. "
        : ""

    return {
        supportPortalUrl,
        supportPortalMessage,
    }
}

/**
 * Hook to get the support portal URL and associated message.
 * In the test environment, redirects to the live Connect Direct site.
 *
 * @returns {SupportPortalUrlResult} - The support portal URL and message
 */
export const useSupportPortalUrl = (): SupportPortalUrlResult =>
    getSupportPortalUrl()
